"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.indicator = exports.progressBar = exports.wrapper = exports.root = void 0;

var _util = require("../../../util");

const root = ({
  theme,
  cssProps
}) => {
  const {
    progress
  } = theme;
  const {
    variant = 'primary',
    borderRadius,
    progressBg,
    isVertical
  } = cssProps;
  const progressTheme = progress[variant];
  const progressBarRootStyle = isVertical ? {
    width: progressTheme.dimension,
    height: '100%'
  } : {
    height: progressTheme.dimension,
    width: '100%'
  };
  return { ...progressBarRootStyle,
    background: progressBg || (0, _util.color)(theme, progressTheme.bg),
    borderRadius: borderRadius || progressTheme.borderRadius,
    overflow: variant === 'primary' ? 'hidden' : undefined
  };
};

exports.root = root;

const wrapper = ({
  theme,
  cssProps
}) => {
  const {
    variant = 'primary',
    isVertical
  } = cssProps;
  const {
    progress
  } = theme;
  const progressTheme = progress[variant];
  const progressBarWrapperStyle = isVertical ? {
    width: progressTheme.dimension
  } : {
    height: progressTheme.dimension
  };
  const progressBarOffsetStyle = isVertical ? {
    maxHeight: "calc(100% - ".concat(progressTheme.offset, "px)"),
    minHeight: progressTheme.offset
  } : {
    maxWidth: "calc(100% - ".concat(progressTheme.offset, "px)"),
    minWidth: progressTheme.offset
  };
  return { ...progressBarWrapperStyle,
    position: 'relative',
    ...(progressTheme.offset ? progressBarOffsetStyle : {})
  };
};

exports.wrapper = wrapper;

const progressBar = ({
  theme,
  cssProps
}) => {
  const {
    progress
  } = theme;
  const {
    variant = 'primary',
    progressColor
  } = cssProps;
  const progressTheme = progress[variant];
  return {
    background: progressColor || (0, _util.color)(theme, progressTheme.progressBg),
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
  };
};

exports.progressBar = progressBar;

const indicator = ({
  theme,
  cssProps
}) => {
  const {
    progress
  } = theme;
  const {
    variant = 'primary',
    isVertical
  } = cssProps;
  const progressTheme = progress[variant];
  const indicatorStyle = isVertical ? {
    width: progressTheme.indicatorDimension,
    height: 2
  } : {
    width: 2,
    height: progressTheme.indicatorDimension
  };
  return { ...indicatorStyle,
    background: (0, _util.color)(theme, progressTheme.indicatorBg),
    borderRadius: '2px 2px 0 0',
    bottom: 0,
    position: 'absolute',
    right: 0,
    transform: 'translateX(50%)'
  };
};

exports.indicator = indicator;
//# sourceMappingURL=Progress.style.js.map